import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import api from "../../lib/api";
import { toast } from "sonner";
import { FileText, Loader2, ArrowRight, Home as HomeIcon } from "lucide-react";

export default function NewQuote() {
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);

  const handleCreate = async () => {
    setCreating(true);
    try {
      const res = await api.post("/quotes");
      toast.success("Quote created", { description: `#${res.data.id.slice(0, 8)} — ${res.data.quote.CreatedBy}` });
      navigate("/quotes/mine");
    } catch {
      toast.error("Failed to create quote");
      setCreating(false);
    }
  };

  return (
    <Layout>
      <div className="mb-6">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-orange-300 bg-orange-500/10 border border-orange-500/20 rounded-full px-3 py-1 mb-3">
          <FileText className="w-3.5 h-3.5" />
          Create Quote
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight" data-testid="new-quote-title">
          Create a new quote
        </h1>
        <p className="text-slate-400 mt-2 text-sm max-w-xl">
          Quotes currently capture just the creator. Full fields (line items, pricing, customer, PDF export) will be added when the workflow is defined.
        </p>
      </div>

      <div className="card-dark p-10 border border-white/5 text-center" data-testid="new-quote-panel">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-orange-500/10 ring-1 ring-orange-500/20 text-orange-300 mb-5">
          <FileText className="w-8 h-8" />
        </div>
        <h2 className="font-display text-2xl font-bold text-white">Ready to create?</h2>
        <p className="text-slate-400 mt-2 text-sm max-w-md mx-auto">
          Clicking below creates a new draft quote assigned to you as the creator.
        </p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={handleCreate}
            disabled={creating}
            className="btn-coral inline-flex items-center gap-2 disabled:opacity-70"
            data-testid="new-quote-create-button"
          >
            {creating ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
            {creating ? "Creating..." : "Create Quote"}
            {!creating && <ArrowRight className="w-4 h-4" />}
          </button>
          <Link
            to="/quotes/all"
            className="inline-flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium border border-white/10 text-slate-200 hover:bg-white/5"
            data-testid="new-quote-cancel"
          >
            <HomeIcon className="w-4 h-4 text-indigo-300" />
            Back to All Quotes
          </Link>
        </div>
      </div>
    </Layout>
  );
}
